import { Component, Input } from '@angular/core';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'duvida',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css']
})
export class TooltipComponent {

  @Input() textoAviso!: any;

  faQuestion = faQuestion;

  constructor(config: NgbTooltipConfig) {
    // Configure a posição do tooltip como "top"
    // config.placement = 'top';
  }

}
